import { render, staticRenderFns } from "./SectionReasons.vue?vue&type=template&id=54e1d51f&"
import script from "./SectionReasons.vue?vue&type=script&lang=js&"
export * from "./SectionReasons.vue?vue&type=script&lang=js&"
import style0 from "./SectionReasons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports